import { render, staticRenderFns } from "./RegionsField.vue?vue&type=template&id=7e1bd017&"
import script from "./RegionsField.vue?vue&type=script&lang=js&"
export * from "./RegionsField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports